import Vue from 'vue';

export const EVENTS = {
    VEHICLE_MAINTENANCE_DATA_UPDATED: 'maintenance-data-updated'
}

export default new Vue();